export function intersect<T>(a: readonly T[], b: readonly T[]): readonly T[] {
  return a.filter(item => b.includes(item));
}
